const common = {
  // Header utility bar
  'common.header.brochure': '資料請求',
  'common.header.news': 'お知らせ',
  'common.header.sitemap': 'サイトマップ',

  // Header logo
  'common.header.logoJa': '日本執事アカデミー',
  'common.header.logoEn': 'THE JAPAN BUTLER ACADEMY / TJBA',

  // Header CTA button
  'common.header.ctaBrochure': '資料請求',

  // Mobile menu aria
  'common.header.menuAriaLabel': 'メニュー',

  // Mobile fixed CTA bar
  'common.mobileCta.brand': 'TJBA',
  'common.mobileCta.brochure': '資料請求',
  'common.mobileCta.apply': '受講お申し込み',

  // Nav items
  'common.nav.home': 'ホーム',
  'common.nav.about': 'アカデミーについて',
  'common.nav.about.overview': 'アカデミー概要',
  'common.nav.about.philosophy': '教育理念・方針',
  'common.nav.about.association': '全日本執事協会について',
  'common.nav.about.facilities': '施設・設備紹介',
  'common.nav.about.access': 'アクセス',
  'common.nav.courses': 'コース紹介',
  'common.nav.courses.list': 'コース一覧・比較',
  'common.nav.courses.essential': 'エッセンシャルコース',
  'common.nav.courses.advanced': 'アドバンスコース',
  'common.nav.courses.master': 'マスターコース',
  'common.nav.courses.schedule': '年間スケジュール',
  'common.footer.courses.recruitment': '開校情報一覧',
  'common.nav.curriculum': 'カリキュラム',
  'common.nav.curriculum.overview': 'カリキュラム概要',
  'common.nav.curriculum.training': '実践トレーニング',
  'common.nav.curriculum.materials': '使用教材',
  'common.nav.curriculum.skills': '習得スキル一覧',
  'common.nav.pricing': '料金・特典',
  'common.nav.pricing.overview': '料金概要',
  'common.nav.pricing.details': 'コース別料金詳細',
  'common.nav.pricing.benefits': '受講特典',
  'common.nav.pricing.certificate': '修了証について',
  'common.nav.admission': '入学案内',
  'common.nav.admission.overview': '入学案内概要',
  'common.nav.admission.application': '応募資格・申込の流れ',
  'common.nav.admission.apply': '申込フォーム',
  'common.nav.admission.consultation': '個別相談予約',
  'common.nav.admission.seminar': '体験講座',
  'common.nav.corporate': '法人研修',
  'common.nav.corporate.overview': '法人研修について',
  'common.nav.corporate.brochure': '法人資料請求',
  'common.nav.contact': 'お問い合わせ',
  'common.nav.contact.form': 'お問い合わせフォーム',
  'common.nav.contact.faq': 'よくある質問',
  'common.nav.contact.brochure': '資料請求',
  'common.nav.contact.blog': '講師ブログ',

  // Footer section headings
  'common.footer.org': '運営情報',
  'common.footer.courses': 'コース',
  'common.footer.support': 'サポート',
  'common.footer.legal': '法的情報',

  // Footer org info
  'common.footer.orgName': '一般社団法人全日本執事協会　日本執事アカデミー（本校）',
  'common.footer.postal': '〒135-0064',
  'common.footer.address': '東京都江東区青海2丁目7-4',
  'common.footer.tel': 'TEL:',
  'common.footer.telNum': '03-6824-4086',
  'common.footer.mail': 'Mail:',
  'common.footer.mailAddr': 'info@butler-academy.jp',

  // Footer course links
  'common.footer.courses.list': 'コース一覧',
  'common.footer.courses.essential': 'エッセンシャルコース',
  'common.footer.courses.advanced': 'アドバンスコース',
  'common.footer.courses.master': 'マスターコース',
  'common.footer.courses.schedule': '年間スケジュール',
  'common.footer.courses.curriculum': 'カリキュラム',

  // Footer support links
  'common.footer.support.admission': '入学案内',
  'common.footer.support.faq': 'よくある質問',
  'common.footer.support.brochure': '資料請求',
  'common.footer.support.consultation': '個別相談',
  'common.footer.support.contact': 'お問い合わせ',
  'common.footer.support.blog': '講師ブログ',
  'common.footer.support.seminar': '体験講座',
  'common.footer.support.related': '関連事業',

  // Footer corporate links (equal-weight group, separate from individual support links)
  'common.footer.corporate': '法人研修',
  'common.footer.corporate.dispatch': '法人研修(出張型)',
  'common.footer.corporate.industries': '業種別プログラム',
  'common.footer.corporate.brochure': '法人資料請求',

  // Footer corporate industry-specific landing pages (full-site coverage)
  'common.footer.corporate.industry.hotel': 'ホテル・旅館',
  'common.footer.corporate.industry.residence': '高級レジデンス',
  'common.footer.corporate.industry.finance': '金融・プライベートバンキング',
  'common.footer.corporate.industry.retail': '百貨店外商・高級小売',
  'common.footer.corporate.industry.luxurySales': 'ラグジュアリー営業',
  'common.footer.corporate.industry.clinic': '医療・美容クリニック',
  'common.footer.corporate.industry.automotive': '自動車・モビリティ',
  'common.footer.corporate.industry.chauffeur': 'ハイヤー・送迎',

  // Footer "About the Academy" column (full-site coverage)
  'common.footer.about.personal': '個人のお客様（通学型コース）',
  'common.footer.guide.academy': '日本執事アカデミーとは',
  'common.footer.guide.school': '執事学校とは？',
  'common.footer.guide.trainingSchool': '執事養成学校とは？',
  'common.footer.guide.job': '執事の仕事とは？',

  // Footer related organizations column: the butler network only (association/
  // service/brand). Non-butler founder ventures are demoted to small copyright-bar
  // links (see familyRomance/ishiiYuichi below) rather than shown as a peer column.
  'common.footer.relatedSites': '関連事業',
  'common.footer.relatedSites.association': '全日本執事協会',
  'common.footer.relatedSites.thebutler': 'THE BUTLER',
  'common.footer.relatedSites.butlerbell': '執事ベル',
  'common.footer.relatedSites.queensbutler': 'Queen\'s Butler',
  'common.footer.relatedSites.viewAll': '関連事業紹介',

  // De-emphasized copyright-bar links: the founder's non-butler ventures
  'common.footer.relatedSites.familyRomance': 'ファミリーロマンス',
  'common.footer.relatedSites.familyRomanceIntro': 'ファミリーロマンスについて',
  'common.footer.relatedSites.ishiiYuichi': '石井裕一オフィシャルサイト',
  'common.footer.relatedSites.ishiiYuichiIntro': '石井裕一について',

  // Footer legal links
  'common.footer.legal.privacy': 'プライバシーポリシー',
  'common.footer.legal.terms': '利用規約',
  'common.footer.legal.commercial': '特定商取引法に基づく表記',

  // Footer copyright
  'common.footer.copyright': '一般社団法人全日本執事協会　日本執事アカデミー（本校） The Japan Butler Academy (TJBA). All Rights Reserved.',

  // og:site_name
  'common.siteName': '日本執事アカデミー',

  // Scroll to top button
  'common.backToTop': 'ページトップへ戻る',

  // Footer: 執事を知る(一般知識)
  'common.footer.knowledge.title': '執事を知る',
  'common.footer.knowledge.job': '執事の仕事とは？',
  'common.footer.knowledge.become': '執事になるには',
  'common.footer.knowledge.school': '執事学校とは？',
  'common.footer.knowledge.trainingSchool': '執事養成学校とは？',
  'common.footer.knowledge.overseas': '海外の執事学校',
  'common.footer.knowledge.history': '執事学校の歴史',
};

export default common;
